// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"691":"645d12e0","702":"a23f7f09","822":"25c84552"}[chunkId] + ".chunk.css";
};